import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMemberStatusDeferredFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0002 2.08301C14.3652 2.08301 17.9168 5.63467 17.9168 9.99967C17.9168 14.3655 14.3652 17.9163 10.0002 17.9163C5.63516 17.9163 2.0835 14.3655 2.0835 9.99967C2.0835 5.63467 5.63516 2.08301 10.0002 2.08301ZM7.96159 7.29134C7.61643 7.29137 7.33659 7.57118 7.33659 7.91634C7.33659 8.2615 7.61643 8.54132 7.96159 8.54134H10.5747L7.47493 11.6411C7.2962 11.8198 7.24233 12.0887 7.33903 12.3223C7.43578 12.5558 7.66406 12.708 7.91683 12.708H12.0835C12.4286 12.7079 12.7085 12.4281 12.7085 12.083C12.7085 11.7379 12.4286 11.4581 12.0835 11.458H9.42562L12.5254 8.35824C12.7041 8.17952 12.758 7.91057 12.6613 7.67708C12.5767 7.47284 12.3912 7.33111 12.1771 7.29867L12.0835 7.29134H7.96159Z"
	})
});
export default SvgMemberStatusDeferredFill;
